// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610151505/js/" + chunkId + "." + {"44":"32fc405a","225":"4a9b58fd","481":"e429bf03","486":"a2e6e48c","770":"f3d35114"}[chunkId] + ".0.374587470899962.chunk.js";
};